import React from 'react';
import { motion } from 'framer-motion';

function PhilosophySection() {
  const philosophyData = [
    {
      number: "01",
      title: "Long-Term Perspective",
      description: "We focus on long-term wealth creation rather than short-term market fluctuations, allowing us to capitalize on sustainable growth opportunities."
    },
    {
      number: "02",
      title: "Risk Management", 
      description: "Our rigorous risk management framework aims to protect capital during market downturns while capturing upside potential during favorable conditions."
    },
    {
      number: "03",
      title: "Diversification",
      description: "We believe in strategic diversification across asset classes, geographies, and investment styles to reduce portfolio volatility and enhance returns."
    },
    {
      number: "04",
      title: "Research-Driven Approach",
      description: "Our investment decisions are based on deep fundamental research, quantitative analysis, and a thorough understanding of global markets."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="max-w-7xl mx-auto px-6">
        <div
          data-aos="fade-up"
          data-aos-delay="100"
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-semibold text-gray-900 mb-4">Our Investment Philosophy</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto text-center">
            Blockfirst Capital follows a disciplined investment approach built on timeless principles and cutting-edge research.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {philosophyData.map((principle, index) => (
            <div
              key={principle.number}
              data-aos="fade-up"
              data-aos-delay={`${200 + index * 100}`}
              className="relative p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 hover:scale-105"
            >
              <div className="absolute -top-4 left-8 w-12 h-12 bg-[#0056d7] text-white rounded-full flex items-center justify-center font-bold text-lg">
                {principle.number}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4 mt-4">{principle.title}</h3>
              <p className="text-gray-600 leading-relaxed">{principle.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PhilosophySection;
